import React, { FunctionComponent, SyntheticEvent } from 'react';
import { Grid, Container } from 'semantic-ui-react';
import withStyles from 'react-jss';

import { Theme } from 'config';
import SelectFilter from 'components/FilterableTable/components/HeaderSelectFilter';
import TextFilter from 'components/FilterableTable/components/HeaderTextFilter';
import { ClassProp } from 'helpers/types';

import {
  Place,
  getUSStateDropdownOptions,
} from 'scenes/Home/scenes/MerchantVenuesOnboarding/MerchantVenuesOnboarding.helpers';

import { usePlacesFilters } from './usePlacesFilter';
import { GET_FILTER_VALUES } from './PlacesFilters.queries';

type Styles = ClassProp<ReturnType<typeof styles>>;

type Props = {
  classes: Styles;
  places: Place[];
};

const defaultFilters = {
  data: {
    placesNameFilter: '',
    placesCityFilter: '',
    placesStateFilter: '',
  },
};

const styles = (theme: Theme) => ({
  container: {
    width: '100% !important',
    justifyContent: 'center !important',
    margin: '2rem auto 0 auto !important',
  },
  reset: {
    display: 'flex !important',
    alignItems: 'end !important',
  },
  resetBtn: {
    color: `${theme.softViolet}`,
    outline: 'none',
    fontSize: '.875rem',
    background: 'transparent',
    border: 'none',
    '&:hover': {
      color: `${theme.violet}`,
    },
  },
});

const PlacesFilters: FunctionComponent<Props> = ({ classes, places }) => {
  const { writeFilterCache } = usePlacesFilters();

  const statesList = getUSStateDropdownOptions(places);
  const handleClick = (_: SyntheticEvent<HTMLElement, Event>) =>
    writeFilterCache(defaultFilters);

  return (
    <Container className={classes.container}>
      <Grid>
        <Grid.Row>
          <Grid.Column width="5">
            <TextFilter
              apolloCacheKey="placesNameFilter"
              label="Name"
              placeholder="filter by name"
              filtersQuery={GET_FILTER_VALUES}
            />
          </Grid.Column>
          <Grid.Column width="5">
            <TextFilter
              apolloCacheKey="placesCityFilter"
              label="City"
              placeholder="filter by city"
              filtersQuery={GET_FILTER_VALUES}
            />
          </Grid.Column>
          <Grid.Column width="4">
            <SelectFilter
              apolloCacheKey="placesStateFilter"
              options={statesList}
              label="State"
              placeholder="filter by state"
              filtersQuery={GET_FILTER_VALUES}
            />
          </Grid.Column>
          <Grid.Column width="2" className={classes.reset}>
            <button className={classes.resetBtn} onClick={handleClick}>
              Reset Filters
            </button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  );
};

export default withStyles(styles)(PlacesFilters);
